<template>
	<section>
		<MainLayout>
			<div class="container">
				<div class="box text-center">
					<div class="">
						<b-avatar size="200px" variant="primary" :text="user.firstName.charAt(0)"></b-avatar>
					</div>
					<hr>
					<b-form @submit="onSubmit">
						<b-form-row>
							<b-form-group class="col" :label="$t('profile.firstName')">
								<b-form-input
									v-model="editUser.firstName"
									type="text"
									required
								></b-form-input>
							</b-form-group>
							<b-form-group class="col" :label="$t('profile.lastName')">
								<b-form-input
									v-model="editUser.lastName"
									type="text"
									required
								></b-form-input>
							</b-form-group>
						</b-form-row>
						<b-form-row>
							<b-form-group class="col" :label="$t('profile.email')">
								<b-form-input
									v-model="editUser.email"
									type="text"
									required
								></b-form-input>
							</b-form-group>
							<b-form-group class="col" :label="$t('profile.phone')">
								<b-form-input
									v-model="editUser.phone"
									type="text"
									required
								></b-form-input>
							</b-form-group>
						</b-form-row>
						<b-form-row>
							<b-form-group class="col" :label="$t('profile.language')">
								<b-form-select size="sm" v-model="editUser.lang" :options="[{value:'en',text:'English'},{value:'es',text:'Español'}]" />
							</b-form-group>
						</b-form-row>
						<br>

						<b-form-row>
							<b-col cols="12" class="mb-3">
								<b-button v-if="!loading" variant="primary" type="submit">{{$t('global.update')}}</b-button>
								<b-button v-else disabled variant="primary" type="submit"><b-spinner small /></b-button>
							</b-col>
							<b-col cols="12" class="mb-3">
								<b-button variant="warning" v-b-modal.update-pass-modal>{{$t('profile.changePassword')}}</b-button>
							</b-col>
						</b-form-row>
					</b-form>
				</div>
			</div>
			<b-modal
				id="update-pass-modal"
				hide-footer
				centered
				no-close-on-backdrop
				no-close-on-esc
				>
					<b-form @submit="doUpdatePassword">
						<b-form-group :label="$t('profile.newPassword')">
							<b-form-input
								v-model="password"
								type="password"
								required
							/>
						</b-form-group>
						<b-form-group :label="$t('profile.repeatPassword')">
							<b-form-input
								v-model="repeatPassword"
								type="password"
								required
							/>
						</b-form-group>
						<hr>
						<div class="text-center">
							<b-button v-if="!loadingUpdatePass" variant="primary" type="submit">{{$t('profile.updatePassword')}}</b-button>
							<b-button v-else disabled variant="primary" type="submit"><b-spinner small /></b-button>
						</div>
					</b-form>
			</b-modal>
		</MainLayout>
	</section>
</template>

<script>
import MainLayout from '../layout/MainLayout.vue'

export default {
	components: {MainLayout},
	data() {
		return {
			password: '',
			repeatPassword: '',
			loading: true,
			loadingUpdatePass: false,
			editUser: {
				firstName: this.$root.store.state.currentUser.firstName,
				lastName: this.$root.store.state.currentUser.lastName,
				phone: this.$root.store.state.currentUser.phone,
				email: this.$root.store.state.currentUser.email,
				lang: this.$root.store.state.currentUser.lang,
			},
		}
	},
	computed: {
		user() {
			return this.$root.store.state.currentUser
		},
	},
	methods: {
		doUpdatePassword(evt) {
			evt.preventDefault();
			if (this.password === this.repeatPassword) {
				this.loading = true;
				this.$root.api.post('/profile/update-passwd', {
					password: this.password
				}).then(() => {
					this.password = ''
					this.repeatPassword = ''
					this.loading = false;
					this.$root.showAlert(this.$t('profile.updatedPassword'))
					this.$root.$emit('bv::hide::modal', "update-pass-modal", evt.target)
				}).catch(this.$root.handleRequestError)
			} else {
				this.$root.showAlert(this.$t('profile.passwordAreDifferent'), {variant: 'danger'})
			}
		},
		onSubmit(evt) {
			evt.preventDefault();
			this.loading = true;
			this.$root.api.put('/profile', this.editUser).then(() => {
				let userData = {};
				Object.assign(userData, this.$root.store.state.currentUser);
				let profileData = {
					firstName: this.editUser.firstName,
					lastName: this.editUser.lastName,
					email: this.editUser.email,
					lang: this.editUser.lang,
					permissions: this.user.permissions
				};
				Object.assign(userData, profileData)
				this.$root.store.setUserData(userData)
				this.$root.$i18n.locale = this.editUser.lang
				this.loading = false;
				this.$root.showAlert(this.$t('profile.updatedData'))
			}).catch(this.$root.handleRequestError)
		},
		fetchUser() {
			this.$root.api.get('/profile').then((res) => {
				this.editUser = {...res.data}
				this.loading = false
			}).catch(this.$root.handleRequestError)
		},
	},
	mounted() {
		this.fetchUser();
	}
}
</script>

<style scoped>
	.container{
		max-width: 600px;
	}
</style>
